import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { sendEmailVerification as firebaseSendEmailVerification } from 'firebase/auth';
import { auth } from '@/lib/firebase';
import RegisterNewCompanyCommandDto from '@/features/auth/signup/types/registerNewCompanyCommandDto.ts';

const signupApi = {
  completeSignup: async (
    completeSignupDto: RegisterNewCompanyCommandDto,
  ): Promise<void> => {
    return await fetchPrivateApi<void>(
      'POST',
      `public/register-company`,
      completeSignupDto,
      { skipTenantId: true },
    );
  },
  sendEmailVerification: async (): Promise<void> => {
    if (import.meta.env.DEV) {
      await firebaseSendEmailVerification(auth.currentUser!);
      await fetchPrivateApi<void>(
        'POST',
        'public/email-verification/send',
        undefined,
        { skipTenantId: true },
      );
    } else {
      await fetchPrivateApi<void>(
        'POST',
        'public/email-verification/send',
        undefined,
        { skipTenantId: true },
      );
    }
  },
};

export default signupApi;
